import * as React from 'react';
import { RouterRequestContext } from '../routerContext';
export function routeProvide(router) {
    return function (request, response) {
        var content = router(request, response);
        return React.createElement(RouterContentWrapper, { content: content, request: request });
    };
}
function RouterContentWrapper(_a) {
    var content = _a.content, request = _a.request;
    return (React.createElement(RouterRequestContext.Provider, { value: request }, content));
}
